<ion-header>
  <div class="left">
    <div class="back-button" (click)="onBackButtonClick()">
      <app-svg-icon [name]="'arrow-back'"></app-svg-icon>
    </div>
    <div class="title">
      {{ "@pages.subsidies.header" | translate }}
    </div>
  </div>
</ion-header>
<div class="padding-md wrap">
  <div *ngIf="(subsidies$ | async) === null" class="app-spinner-container">
    <ion-spinner class="app-spinner"></ion-spinner>
  </div>
  <div *ngIf="subsidies$ | async as subsidies" class="list">
    <div *ngIf="subsidies.length! > 0" class="list-header">
      {{ "@pages.subsidies.list.header" | translate }}
    </div>
    <div *ngFor="let subsidyItem of subsidies" class="list-item">
      <div class="amount">
        {{ (subsidyItem.subsidy | appCurrency | async)!.asString() }}
      </div>
      <div class="locations">
        <!-- <div class="label">
          {{ "@pages.subsidies.activeFor.header" | translate }}:
        </div> -->
        <div
          *ngFor="let location of subsidyItem.locations"
          class="location-name"
        >
          {{ location.name }}
        </div>
      </div>
    </div>
    <div *ngIf="subsidies.length === 0" class="empty-list-message">
      {{ "@pages.subsidies.emptyListMessage" | translate }}
    </div>
  </div>

  <div class="footer">
    <app-action-button
      [label]="'@pages.subsidies.cta' | translate"
      (click)="onActivateCodeClick()"
    ></app-action-button>
  </div>
</div>
